import getFullComposeViewState from './getFullComposeViewState';
import isTimeSuggestionsEnabled from '../utils/isTimeSuggestionsEnabled';

export default function shouldShowTimeSuggestions() {
    const fullComposeViewState = getFullComposeViewState();
    const timeSuggestionsEnabled = isTimeSuggestionsEnabled();

    if (fullComposeViewState) {
        return !fullComposeViewState.isAcceptProposeNewTime && timeSuggestionsEnabled;
    }

    return timeSuggestionsEnabled;
}
